/** `kind: 'none'`: nothing to send, but a blank phone mid-round reads as broken. */

import type { InputSpec } from '@gsf/contract';
import type { RendererProps } from '../renderer';

export function NoneInput({ request, spec }: RendererProps<Extract<InputSpec, { kind: 'none' }>>) {
  return <p className="play-hint">{spec.message ?? request.prompt}</p>;
}
